<template>
    <ul class="footer-links">
        <li v-for="(item, i) in footerlink" :key="i" class="mb-4">
            <router-link :to="item.path" class="flex items-center text-gray font-normal text-sm leading-6">
                {{item.title}} <span v-if="item.newTag" class="new bg-darkyellow inline-block text-darken uppercase px-spc36 pt-spc13 pb-spc11 text-xs leading-spc8 ml-spc35">{{item.newTag}}</span>
            </router-link>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "FooterLinks",
        props: ['footerlink'],
    }
</script>

<style scoped>

</style>